export default __webpack_public_path__ + "static/mening-home-7d340683382b7ebeb0e82a341f1ecb60.png";